import React from 'react';
import { List } from 'semantic-ui-react';

import WorkshopDate from '../../components/workshops/WorkshopDate';
import { bem } from '../../core/design/bem';
import { ProgramEntry } from '../types';

const css = bem('GroupDetailsModal');

type ProgramSectionProps = {
  entries: ProgramEntry[];
  /** Titre de la section ("Démos", "Conférences") */
  title: string;
  /** Formats de date, comme sur les autres blocs (`dateConfig`) */
  dateConfig?: Record<string, unknown>;
};

/** Une partie du programme de visite : les démos, ou les conférences */
const ProgramSection = ({
  entries,
  title,
  dateConfig,
}: ProgramSectionProps): JSX.Element | null => {
  if (!entries.length) return null;

  return (
    <>
      <h5 className={css('program-title').toString()}>{title}</h5>
      <List divided relaxed className={css('program').toString()}>
        {entries.map((entry, index) => (
          <List.Item
            // eslint-disable-next-line react/no-array-index-key
            key={`${entry.type}-${entry.id || index}`}
            className={css('program-item').toString()}
          >
            <span className={css('program-index').toString()}>
              {String(index + 1).padStart(2, '0')}
            </span>
            <List.Content className={css('program-label').toString()}>
              <span className={css('program-name').toString()}>{entry.label}</span>
              {entry.startDate && (
                <WorkshopDate
                  className={css('program-schedule').toString()}
                  startDate={entry.startDate}
                  endDate={entry.endDate}
                  showDay
                  showEndTime
                  showIcons={false}
                  showTimezone={false}
                  dateConfig={dateConfig}
                />
              )}
              {entry.day && <span className={css('program-schedule').toString()}>{entry.day}</span>}
            </List.Content>
          </List.Item>
        ))}
      </List>
    </>
  );
};

ProgramSection.defaultProps = {
  dateConfig: undefined,
};

export default ProgramSection;
